module.exports = __webpack_public_path__ + "img/design.eefb02ed.png";